export default "__VITE_ASSET__069b332f__"